import TemplateView from '../../TemplateView'
import {escapeHtmlSymbols} from '../../atUtils'
import CommentsNumberContainer from '../components/CommentsNumberContainer'


export default class NamesCell extends TemplateView {
    constructor({
        tokensHighlighter,
    } = {}) {
        super()

        this.tokensHighlighter = tokensHighlighter

        this.state = {
            taskName: "",
            projectName: "",
            customerName: "",
            commentsNumber: 0,
        }

        this.onStatePropertyChanged('taskName', (taskName) => {
            this.$title.html(this.tokensHighlighter ? this.tokensHighlighter.highlightTokens(taskName) : escapeHtmlSymbols(taskName))
            this._updateTooltip(this.$title, taskName)
        })

        this.onStatePropertyChanged('customerName', (customerName) => {
            this.$customerTitle.text(customerName)
        })

        this.onStatePropertyChanged('projectName', (projectName) => {
            this.$projectTitle.text(projectName)
        })

        this.onAnyStatePropertyChanged(['customerName', 'projectName'], () => {
            this.$arrowIcon.toggle(!!this.state.projectName && !!this.state.customerName)
            this._updateTooltip(this.$subtitle, this._getSubtitleTooltip(this.state.projectName, this.state.customerName))
        })

        this.onStatePropertyChanged('commentsNumber', (num) => {
            this.commentsNumber.setState({
                commentsNumber: num,
            })
        })

    }

    templateHtml() {
        return "<div class='namesCell_taskManagement'>" +
               "  <div class='namesContainer'>" +
               "    <div class='subtitle'>" +
               "      <div class='customerTitle'></div>" +
               "      <div class='arrow'></div>" +
               "      <div class='projectTitle'></div>" +
               "    </div>" +
               "    <div class='title'></div>" +
               "  </div>" +
               "  <div class='commentsNumberPlaceholder'></div>" +
               "</div>"
    }

    afterRender() {
        this.$subtitle = this.find('.subtitle')
        this.$customerTitle = this.find('.customerTitle')
        this.$projectTitle = this.find('.projectTitle')
        this.$title = this.find('.title')
        this.$arrowIcon = this.find('.arrow')

        this.commentsNumber = new CommentsNumberContainer().init(this.find('.commentsNumberPlaceholder'))
    }

    _updateTooltip($elem, tooltipText) {
        $elem.attr('title', tooltipText)
    }

    _getSubtitleTooltip(projectName, customerName) {
        let tooltip = ''
        if (customerName && projectName)
            tooltip = customerName + ' > ' + projectName
        else if (projectName)
            tooltip = projectName

        return tooltip
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/NamesCell.js